// VideoPreview.tsx
import React, { memo, useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const VideoPreview = memo(({ 
  src, 
  onRemove, 
  className 
}: { 
  src: string; 
  onRemove: (e: React.MouseEvent) => void; 
  className?: string 
}) => {
  const [videoUrl, setVideoUrl] = useState<string>(src);

  useEffect(() => {
    setVideoUrl(src);
    return () => {
      URL.revokeObjectURL(videoUrl);
    };
  }, [src]);

  return (
    <div className="block rounded-[20px] overflow-hidden relative w-full h-full">
      <video
        className={className}
        src={videoUrl}
        controls
        key={videoUrl} // Add key to force re-render
      />
      <span
        onClick={onRemove}
        className="absolute top-2 right-2 w-6 h-6 bg-white text-black rounded-full flex items-center justify-center shadow-md z-10 cursor-pointer"
      >
        <IoClose size={16} />
      </span>
    </div>
  );
});

export default VideoPreview;